import React from "react";
import { ShoppingCart, Receipt, Landmark } from "lucide-react";
import { selectCls, STATUS_DOT, docsLabel } from "@/components/accounting/ui";

const CARDS = [
  { id: "einkauf", label: "Einkauf", unit: "Belege", icon: ShoppingCart },
  { id: "verkauf", label: "Verkauf", unit: "Belege", icon: Receipt },
  { id: "bank", label: "Bank", unit: "Dokumente", icon: Landmark },
];

export const MonthPicker = ({ period, setPeriod, months, monthNames, firstYear }) => {
  const [y, m] = period.split("-");
  const last = new Date().getFullYear() + 1;
  const years = Array.from({ length: last - firstYear + 1 }, (_, i) => String(last - i));
  return (
    <div data-testid="acc-month-picker">
      <div className="flex flex-wrap items-center gap-2">
        <select data-testid="acc-month-select" aria-label="Monat" value={m} onChange={(e) => setPeriod(`${y}-${e.target.value}`)} className={selectCls}>
          {monthNames.map((n, i) => <option key={n} value={String(i + 1).padStart(2, "0")}>{n}</option>)}
        </select>
        <select data-testid="acc-year-select" aria-label="Jahr" value={y} onChange={(e) => setPeriod(`${e.target.value}-${m}`)} className={selectCls}>
          {years.map((yy) => <option key={yy} value={yy}>{yy}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-6 md:grid-cols-12 gap-1.5 mt-4" data-testid="acc-year-strip">
        {months.map((mo, i) => {
          const active = mo.period === period;
          return (
            <button key={mo.period} type="button" onClick={() => setPeriod(mo.period)} data-testid={`acc-month-chip-${mo.period}`}
              title={`${mo.label}: ${docsLabel(mo.total)}`}
              className={`rounded-lg border px-2 py-2 text-left transition-colors ${active ? "border-ink bg-surface shadow-sm" : "border-line bg-surface/60 hover:border-silver"}`}>
              <span className={`block text-[11px] font-semibold ${active ? "text-ink" : "text-dim"}`}>{monthNames[i].slice(0, 3)}</span>
              <span className="flex items-center gap-1.5 mt-1">
                <span className={`w-1.5 h-1.5 rounded-full ${STATUS_DOT[mo.status]}`} />
                <span className="text-[10px] text-faint">{mo.total}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const SummaryCards = ({ counts, category, setCategory }) => (
  <div className="grid grid-cols-3 gap-3 md:gap-4" data-testid="acc-summary-cards">
    {CARDS.map(({ id, label, unit, icon: Icon }) => {
      const active = category === id;
      return (
        <button key={id} type="button" onClick={() => setCategory(active ? "" : id)} data-testid={`acc-card-${id}`} aria-pressed={active}
          className={`text-left rounded-xl border bg-surface p-4 md:p-5 transition-colors ${active ? "border-brand ring-1 ring-brand" : "border-line hover:border-silver"}`}>
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-elevated text-brand"><Icon size={15} strokeWidth={1.8} /></span>
          <p className="font-display font-bold text-2xl md:text-3xl text-ink mt-3" data-testid={`acc-count-${id}`}>{counts[id]}</p>
          <p className="text-xs text-faint mt-1 font-medium">{label}<span className="hidden sm:inline"> · {unit}</span></p>
        </button>
      );
    })}
  </div>
);
